import InitialReviewFollowUpPage from "../../shared/initialReviewFollowUp/InitialReviewFollowUpPage";

const MODIFY_PATH = "/SLN/SolarentOperator/CheckNewRequest";

export default function SolarentOperatorInitialReviewFollowUpPage() {
  return <InitialReviewFollowUpPage modifyPath={MODIFY_PATH} />;
}
